import { UtilService } from './../../shared/util.service';
import { Observable, BehaviorSubject, Subject, forkJoin } from 'rxjs';

import { Injectable } from '@angular/core';

import { HttpHelpersService } from '../../shared/http-helpers.service';
import { UserData } from '../../models/UserData';
import { UserService } from '../../shared/user.service';
import { CHECKOUT_API_URL, EVENTS_API_URL } from '../../consts/appConsts';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { SMARTBOOK, GETBOOKPRICEBYPAGES, UPDATE_ALBUM, SEND_EVENT } from '../../consts/apiMethods';
import { throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../shared/token.service';

const SMALL_BOOK_FORMAT = '27';
const HARD_COVER = '0';
const NORMAL_PAGE_TYPE = '0';
const SOFT_COVER = '1';

const SOURCE_ONLINE_CLIENT = 'ONLINE_CLIENT';

const SERVICE_API = 'online.header';
const ERROR_CODE_ONLINE_PAYMENT = 13;

@Injectable()
export class HeaderService {
    noBack: boolean;
    smartbookData: any;
    private smartbookSubject: BehaviorSubject<any> = new BehaviorSubject(undefined);
    bookName = new Subject<string>();
    // nameChanged = new Subject<string>();
    $updatedTree = new BehaviorSubject(undefined);
    upsaleAction = new Subject<boolean>();

    $reopenBook: BehaviorSubject<boolean> = new BehaviorSubject(false);
    $disableBack: BehaviorSubject<boolean> = new BehaviorSubject(false);
    $userName: BehaviorSubject<string> = new BehaviorSubject(undefined);
    $toggleBookName: BehaviorSubject<boolean> = new BehaviorSubject(true);
    $toggleSideMenu = new Subject<boolean>();
    $openNameEditor = new Subject<boolean>();
    $bookPrice = new Subject<any>();
    cleanStack = new Subject<boolean>();

    $isLoginIframe: BehaviorSubject<boolean> = new BehaviorSubject(false);
    $isPlacingEditor: BehaviorSubject<boolean> = new BehaviorSubject(false);
    name: string;

    constructor(
        private httpHelperService: HttpHelpersService,
        private userService: UserService,
        private tokenService: TokenService,
        private util: UtilService
    ) {
        this.userService.$userData.subscribe(this.SetUserData);
    }
    // get album data and price
    setDirectOrder() {
        this.httpHelperService.ajax('get', { method: SMARTBOOK }).subscribe((response) => {
            this.smartbookData = response;
            this.smartbookSubject.next(this.smartbookData);
        });
    }
    removeDirectOrder() {
        this.smartbookSubject.next(null);
    }
    getAlbumData(): Observable<any> {
        return this.smartbookSubject.asObservable();
    }
    setBookName(name: string) {
        this.name = name;
        this.bookName.next(name);
    }
    getBookName(): Observable<string> {
        return this.bookName.asObservable();
    }

    reopenBook() {
        this.$reopenBook.next(true);
    }

    cancelReopenBook() {
        this.$reopenBook.next(false);
    }

    disableBack() {
        // console.log('disable');
        this.$disableBack.next(true);
    }
    enableBack() {
        this.$disableBack.next(false);
    }
    setUserName(name) {
        this.$userName.next(name);
    }
    hideBookName() {
        this.$toggleBookName.next(false);
    }
    showBookName() {
        this.$toggleBookName.next(true);
    }
    openNameEditor() {
        this.$openNameEditor.next(true);
    }
    private SetUserData = (userData: UserData) => {
        if (!userData) {
            return;
        }
        this.setUserName(userData.firstName);
        // tslint:disable-next-line:semicolon
    };
    getBookNameAsString = (): string => {
        return this.name;
    };
    updatePrice(pages) {
        const params = {
            method: GETBOOKPRICEBYPAGES,
            format: SMALL_BOOK_FORMAT,
            covertype: HARD_COVER,
            pagetype: NORMAL_PAGE_TYPE,
            quantity: 1,
            pages: pages,
        };

        const coverHard$ = this.httpHelperService
            .ajax('get', params, CHECKOUT_API_URL, null, false, environment.basePaymentApi)
            .pipe(
                map((response) => {
                    return response[0];
                })
            );
        params.covertype = SOFT_COVER;
        const coverSoft$ = this.httpHelperService
            .ajax('get', params, CHECKOUT_API_URL, null, false, environment.basePaymentApi)
            .pipe(
                map((response) => {
                    return response[0];
                })
            );
        forkJoin([coverHard$, coverSoft$]).subscribe((results) => {
            const newPrices = {
                bookPrice: results[0].SalePrice,
                bookPriceOriginal: results[0].price,
                bookPriceSoft: results[1].SalePrice,
                bookPriceSoftOriginal: results[1].price,
            };
            this.$bookPrice.next(newPrices);
        });
    }
    cleanBackStack() {
        this.cleanStack.next(true);
    }
    updateName(newName, dontUpdateTree?: boolean) {
        return this.httpHelperService
            .ajax('get', {
                method: UPDATE_ALBUM,
                album_name: encodeURIComponent(newName),
            })
            .pipe(
                map((response) => {
                    this.setBookName(newName);
                    // if (!dontUpdateTree) {
                    //    this.nameChanged.next(newName);
                    if (response) {
                        let newTree = response.tree;
                        if (newTree) {
                            this.$updatedTree.next(newTree);
                        }
                    }
                    // }
                })
            );
    }

    setLoginIframePage(isLoginIframe: boolean) {
        this.$isLoginIframe.next(isLoginIframe);
    }

    sendEvent(eventName, leanPlumObj) {
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

        const params = {
            method: SEND_EVENT,
            lean_plum: JSON.stringify(leanPlumObj),
            event: eventName,
        };

        return this.httpHelperService
            .ajax('post', params, EVENTS_API_URL, headers, true)
            .subscribe((res) => {});
    }

    // writeError(serviceApi, token, errorCode, extraParams, active)
    // {
    //     var url = "https://monitor.lupa.co.il//api//api.aspx?method=write_error&source=" + SOURCE_ONLINE_CLIENT +"&service_api=" + serviceApi + "&token=" + token + "&error_code=" + errorCode +  "&active=" + active;
    //     // var url = "https://146.148.2.80//api//api.aspx?method=write_error&source=" + SOURCE_ONLINE_CLIENT +"&service_api=" + serviceApi + "&token=" + token + "&error_code=" + errorCode +  "&active=" + active;
    //    console.log(extraParams);
    //    console.log("stringfy");
    //    console.log(JSON.stringify({"extra_params" : extraParams}));

    //    let formData = new FormData();

    //    formData.append("extra_params", extraParams);

    //     fetch(url, {
    //         mode: "no-cors",
    //         headers: {
    //           'Accept': 'application/json',
    //           'Content-Type': 'application/json'
    //         },
    //         credentials: "include",
    //         method: "POST",
    //         body: formData
    //     })
    // }
}
